import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedAccount } from '../../../../../../selectors/tools';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import DTAccountSearchView from '../../DTAccountSearchView';

const DTSelectAccountNode = () => {
  const dispatch = useDispatch();
  const selectedAccount = useSelector(getSelectedAccount);

  const handleNextButtonClick = () => dispatch(addEdgeToDecisionTreePath('account_selected'));

  return (
    <DTAccountSearchView onNextButtonClick={handleNextButtonClick} isNextButtonActive={!isEmpty(selectedAccount)} />
  );
};

export default DTSelectAccountNode;
